import _ from 'lodash';

function EventAnalysisCtrl($http, $rootScope, $scope, $state, $stateParams, $timeout, $interval, toastr, AppSettings, ChartGeneratorService, PlanService, EventAnalysisService, AnalysisService, PlayerService, AppContextService) {
  'ngInject';

  const vm = this;
  vm.appContext = AppContextService.context;
  vm.period = 'A'
  vm.categories_C = ['HB', 'OS', 'LA', 'BT'];
  vm.categories_D = ['DS', 'VL', 'CL', 'BW', 'IJ'];
  vm.secondOrPeriod = 'period'

  var series_data = [];
  vm.indexA = 0;
  vm.indexB = 0;
  vm.indexC = 0;
  vm.indexD = 0;

  let number_format = d3.format(',');

  let liquidGaugeSize = {
    width: '90px',
    height: '90px'
  };

  vm.showMovementData = false;  // 동작분석
  vm.showBioData = false;       // 생체분석
  vm.showLocationData = false;  // 전술분석

  AnalysisService.getLocationList()
    .then(function (res) {
      vm.locations = res.data.data;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

  vm.categories = {
    'device': [
      {
        title: '디바이스',
        items: [
          {
            name: '디바이스',
            title: true,
            selected: true
          },
          {
            name: '워킹',
            title: false,
            selected: false
          },
          {
            name: '스프린트',
            title: false,
            selected: false
          },
          {
            name: '러닝',
            title: false,
            selected: false
          },
          {
            name: '속도',
            title: false,
            selected: false
          },
          {
            name: '거리',
            title: false,
            selected: false
          },
          {
            name: '가속도',
            title: false,
            selected: false
          }
        ]
      },
    ],
    'movement': [
      {
        title: '동작',
        items: [
          {
            name: '동작',
            title: true,
            selected: true
          },
          {
            name: '워킹',
            title: false,
            selected: false
          },
          {
            name: '스프린트',
            title: false,
            selected: false
          },
          {
            name: '러닝',
            title: false,
            selected: false
          },
          {
            name: '점프',
            title: false,
            selected: false
          },
          {
            name: '턴',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '트래핑',
        items: [
          {
            name: '트래핑',
            title: true,
            selected: true
          },
          {
            name: '땅볼',
            title: false,
            selected: false
          },
          {
            name: '가슴',
            title: false,
            selected: false
          },
          {
            name: '허벅지',
            title: false,
            selected: false
          },
          {
            name: '이동',
            title: false,
            selected: false
          },
          {
            name: '공중볼',
            title: false,
            selected: false
          },
          {
            name: '턴',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '드리블',
        items: [
          {
            name: '드리블',
            title: true,
            selected: true
          },
          {
            name: '볼터치',
            title: false,
            selected: false
          },
          {
            name: '직진',
            title: false,
            selected: false
          },
          {
            name: '방향전환',
            title: false,
            selected: false
          },
          {
            name: '이동',
            title: false,
            selected: false
          },
          {
            name: '페인팅',
            title: false,
            selected: false
          },
          {
            name: '팬텀',
            title: false,
            selected: false
          },
          {
            name: '크루이프턴',
            title: false,
            selected: false
          },
          {
            name: '마르세유턴',
            title: false,
            selected: false
          },
          {
            name: '스텝오버',
            title: false,
            selected: false
          },
          {
            name: '플리플랩',
            title: false,
            selected: false
          },
          {
            name: '맥기디스핀',
            title: false,
            selected: false
          },
          {
            name: '스쿱턴',
            title: false,
            selected: false
          },
          {
            name: '포커스포커스',
            title: false,
            selected: false
          },
          {
            name: '사포',
            title: false,
            selected: false
          },
          {
            name: '돌파',
            title: false,
            selected: false
          },
          {
            name: '돌파허용',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '패스',
        items: [
          {
            name: '패스',
            title: true,
            selected: true
          },
          {
            name: '논스톱',
            title: false,
            selected: false
          },
          {
            name: '원터치',
            title: false,
            selected: false
          },
          {
            name: '스루',
            title: false,
            selected: false
          },
          {
            name: '2V1',
            title: false,
            selected: false
          },
          {
            name: '3자',
            title: false,
            selected: false
          },
          {
            name: '킬',
            title: false,
            selected: false
          },
          {
            name: '침투',
            title: false,
            selected: false
          },
          {
            name: '헤딩',
            title: false,
            selected: false
          },
          {
            name: '피드',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '슈팅',
        items: [
          {
            name: '슈팅',
            title: true,
            selected: true
          },
          {
            name: '원터치',
            title: false,
            selected: false
          },
          {
            name: '발리',
            title: false,
            selected: false
          },
          {
            name: '오버헤드',
            title: false,
            selected: false
          },
          {
            name: '헤딩',
            title: false,
            selected: false
          },
          {
            name: '칩샷',
            title: false,
            selected: false
          },
          {
            name: '위협',
            title: false,
            selected: false
          },
          {
            name: '유효',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '킥',
        items: [
          {
            name: '킥',
            title: true,
            selected: true
          },
          {
            name: '롱',
            title: false,
            selected: false
          },
          {
            name: '짧은',
            title: false,
            selected: false
          },
          {
            name: '다이렉트',
            title: false,
            selected: false
          },
          {
            name: '파넨카',
            title: false,
            selected: false
          },
          {
            name: '드롭',
            title: false,
            selected: false
          },
          {
            name: '라보나',
            title: false,
            selected: false
          },
          {
            name: '스핀',
            title: false,
            selected: false
          },
          {
            name: '바이시클',
            title: false,
            selected: false
          },
          {
            name: '힐',
            title: false,
            selected: false
          }  
        ]
      },
      {
        title: '크로싱',
        items: [
          {
            name: '크로싱',
            title: true,
            selected: true
          },
          {
            name: '얼리',
            title: false,
            selected: false
          },
          {
            name: '레이트',
            title: false,
            selected: false
          },
          {
            name: '컷백',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '태클',
        items: [
          {
            name: '태클',
            title: true,
            selected: true
          },
          {
            name: '포크',
            title: false,
            selected: false
          },
          {
            name: '슬라이딩',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: 'GK',
        items: [
          {
            name: 'GK',
            title: true,
            selected: true
          },
          {
            name: '캐칭',
            title: false,
            selected: false
          },
          {
            name: '세이빙',
            title: false,
            selected: false
          },
          {
            name: '일대일',
            title: false,
            selected: false
          },
          {
            name: '슈퍼세이브',
            title: false,
            selected: false
          },
          {
            name: '실책',
            title: false,
            selected: false
          }
        ]
      }
    ],
    'bio': [
      {
        title: '컨디션',
        items: [
          {
            name: '컨디션',
            title: true,
            selected: true
          },
          {
            name: '심박수',
            title: false,
            selected: false
          },
          {
            name: '체온',
            title: false,
            selected: false
          },
          {
            name: '산소포화도',
            title: false,
            selected: false
          },
          {
            name: '칼로리',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '컨디션2',
        items: [
          {
            name: '컨디션2',
            title: true,
            selected: true
          },
          {
            name: '젖산',
            title: false,
            selected: false
          },
          {
            name: '폐활량',
            title: false,
            selected: false
          },
          {
            name: '체중',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '컨디션3',
        items: [
          {
            name: '컨디션3',
            title: true,
            selected: true
          },
          {
            name: '체수분',
            title: false,
            selected: false
          },
          {
            name: '체지방',
            title: false,
            selected: false
          },
          {
            name: '골격근',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '컨디션4',
        items: [
          {
            name: '컨디션4',
            title: true,
            selected: true
          },
          {
            name: '혈당',
            title: false,
            selected: false
          },
          {
            name: '혈압',
            title: false,
            selected: false
          },
          {
            name: '단백질',
            title: false,
            selected: false
          }
        ]
      }
    ],
    'location': [
      {
        title: '경기결과',
        items: [
          {
            name: '경기결과',
            title: true,
            selected: true
          },
          {
            name: '득점',
            title: false,
            selected: false
          },
          {
            name: '실점',
            title: false,
            selected: false
          },
          {
            name: '자책골',
            title: false,
            selected: false
          },
          {
            name: '파울',
            title: false,
            selected: false
          },
          {
            name: '경고',
            title: false,
            selected: false
          },
          {
            name: '퇴장',
            title: false,
            selected: false
          },
          {
            name: '오프사이드',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '세트피스',
        items: [
          {
            name: '세트피스',
            title: true,
            selected: true
          },
          {
            name: '골킥',
            title: false,
            selected: false
          },
          {
            name: '스로잉',
            title: false,
            selected: false
          },
          {
            name: '코너킥',
            title: false,
            selected: false
          },
          {
            name: '프리킥',
            title: false,
            selected: false
          },
          {
            name: '페널티킥',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '수비',
        items: [
          {
            name: '수비',
            title: true,
            selected: true
          },
          {
            name: '가로채기',
            title: false,
            selected: false
          },
          {
            name: '클리어',
            title: false,
            selected: false
          },
          {
            name: '그라운드경합',
            title: false,
            selected: false
          },
          {
            name: '공중볼경합',
            title: false,
            selected: false
          },
          {
            name: '압박',
            title: false,
            selected: false
          },
          {
            name: '세컨볼',
            title: false,
            selected: false
          },
          {
            name: '그라운드차단',
            title: false,
            selected: false
          },
          {
            name: '공중볼차단',
            title: false,
            selected: false
          },
          {
            name: '패스차단',
            title: false,
            selected: false
          }
        ]
      }
    ]
  };

  /*
   * SGS 7, SGS 70, SGS 700 메뉴에서 동작 데이터 표시 업데이트
   */
  // type1 에 대한 count update
  vm.appContext.updateType1Count = function() {
    $('div.display-data').find('span.count1').each(function() {
      var span = $(this),
        parent = span.parent(),
        count = 0,
        type1 = parent.data('type1');

      _.each(vm.appContext.deviceData, function(item) {
        if (item.type1 === type1) {
          count = count + 1;
        }
      });

      span.html(count);
    });
  };

  // type2 에 대한 count update
  vm.appContext.updateType2Count = function() {
    $('div.display-data').find('span.count2').each(function() {
      var span = $(this),
        parent = span.parent(),
        count = 0,
        type2 = parent.data('type2');

      _.each(vm.appContext.deviceData, function(item) {
        if (item.type2 === type2) {
          count = count + 1;
        }
      });

      span.html(count);
    });
  };

  // type3 에 대한 count update
  vm.appContext.updateType3Count = function() {
    $('div.display-data').find('span.count3').each(function() {
      var span = $(this),
        parent = span.parent(),
        count = 0,
        type3 = parent.data('type3');

      _.each(vm.appContext.deviceData, function(item) {
        if (item.type3 === type3) {
          count = count + 1;
        }
      });

      span.html(count);
    });
  };

  // type4 에 대한 count update
  vm.appContext.updateType4Count = function() {
    // vm.selectedDeviceData = _.filter(vm.appContext.deviceData, {
    //   type1: vm.saveMeta.type1,
    //   type2: vm.saveMeta.type2,
    //   type3: vm.saveMeta.type3
    // });

    vm.selectedDeviceData = vm.appContext.deviceData;

    $('div.display-data').find('span.left').html('0');
    $('div.display-data').find('span.right').html('0');

    $('div.display-data').find('span.count4').each(function() {
      var span = $(this),
        parent = span.parent(),
        parentTagName = parent[0].tagName,
        count = 0,
        type4 = parent.data('type4');

      var type4L = parent.find('span.type4-L'),
        type4R = parent.find('span.type4-R'),
        type4I = parent.find('span.type4-I'),
        type4O = parent.find('span.type4-O'),
        type4IS = parent.find('span.type4-IS'),
        type4SO = parent.find('span.type4-SO'),	
        type4ST = parent.find('span.type4-ST');;
      type4L.html('0');
      type4R.html('0');
      type4I.html('0');
      type4O.html('0');
      type4IS.html('0');
      type4SO.html('0');	
      type4ST.html('0');

      _.each(vm.selectedDeviceData, function(item) {
        if (item.type4 === type4) {
          count = count + 1;

          // td 내부의 span 일 경우 상위의 th 를 찾아서 count 를 더함
          if (parentTagName === 'TD') {
            var th,
              left,
              right;
            if (span.closest('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
            }

            if (th) {
              th.find('span.count4').html(+(th.find('span.count4').html()) + 1);

              left = th.next('td').find('span.left');
              right = th.next('td').next('td').find('span.right');

              if (left && item.type3 === 'L') {
                left.html(+(left.html()) + 1);
              } else if (right && item.type3 === 'R') {
                right.html(+(right.html()) + 1);
              }
            }
          }
          
          if (item.type3 === 'L') {
            type4L.html(+(type4L.html()) + 1);
          } else if (item.type3 === 'R') {
            type4R.html(+(type4R.html()) + 1);
          }
          if (item.type2 === '인사이드') {
            type4I.html(+(type4I.html()) + 1);
          } else if (item.type2 === '아웃사이드') {
            type4O.html(+(type4O.html()) + 1);
          } else if (item.type2 === '인스텝') {
            type4IS.html(+(type4IS.html()) + 1);
          } else if (item.type2 === '발바닥') {	
            type4SO.html(+(type4SO.html()) + 1);	
          }	

           try {	
            let stride = JSON.parse(item.point);	
            stride = (stride[9] + stride[19]) / 2;	

             type4ST.html(+(type4ST.html()) + stride);
             
             $('#device-stride-value').html(stride);
          } catch(e) {	
            console.log(e);	
          }
        }
      });

      span.html(count);
    });
  };

  // type6 에 대한 count update
  vm.appContext.updateType6Count = function() {
    // 위치에 해당하는 동작에 대해서는 업데이트 하지 않음
    var locationType4s = ['크로싱', '얼리크로싱', '레이트크로싱', '컷백', '수비', '가로채기', '클리어', '그라운드경합', '공중볼경합', '압박', '세컨볼', '그라운드패스차단', '공중볼패스차단', '패스차단', '경기결과', '득점', '실점', '자책골', '파울', '경고', '퇴장', '오프사이드', '세트피스', '골킥', '스로잉', '코너킥', '프리킥', '페널티킥'];

    $('div.display-data').find('span.count6').each(function() {
      var span = $(this),
        parent = span.parent(),
        count = 0,
        type6 = parent.data('type6');

      _.each(vm.appContext.deviceData, function(item) {
        if (item.type6 === type6) {
          if (locationType4s.indexOf(item.type4) > -1) {
            return;
          }
          
          count = count + 1;
        }
      });

      span.html(count);
    });
  };

  // type7 에 대한 count update
  vm.appContext.updateType7Count = function() {
    $('div.display-data').find('span.count7').each(function() {
      var span = $(this),
        parent = span.parent(),
        parentTagName = parent[0].tagName,
        count = 0,
        type7 = parent.data('type7');

      var type7L = parent.find('span.type7-L'),
      type7R = parent.find('span.type7-R'),
      type7I = parent.find('span.type7-I'),
      type7O = parent.find('span.type7-O'),
      type7IS = parent.find('span.type7-IS'),
      type7SO = parent.find('span.type7-SO'),
      type7ST = parent.find('span.type7-ST');
      type7L.html('0');
      type7R.html('0');
      type7I.html('0');
      type7O.html('0');
      type7IS.html('0');
      type7SO.html('0');	
      type7ST.html('0');

      _.each(vm.appContext.deviceData, function(item) {
        if (item.type7 === type7 || (type7 === '워킹' && item.type4 === '워킹') || (type7 === '스프린트' && item.type4 === '스프린트') || (type7 === '러닝' && item.type4 === '러닝') || (type7 === '점프' && item.type4 === '점프') || (type7 === '턴' && item.type4 === '턴')) {
          count = count + 1;

          // 워킹, 러닝 거리 표시
          if (item.type7 === '워킹') {
            $('#walking-distance').html((count * 0.0007).toFixed(3) + 'km');
          } else if (item.type7 === '러닝') {
            $('#running-distance').html((count * 0.001).toFixed(3) + 'km');
          }

          // td 내부의 span 일 경우 상위의 th 를 찾아서 count 를 더함
          if (parentTagName === 'TD') {
            var th,
              left,
              right;
            if (span.closest('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
            } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
              th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
            }

            if (th) {
              th.find('span.count7').html(+(th.find('span.count7').html()) + 1);

              left = th.next('td').find('span.left');
              right = th.next('td').next('td').find('span.right');

              if (left && item.type3 === 'L') {
                left.html(+(left.html()) + 1);
              } else if (right && item.type3 === 'R') {
                right.html(+(right.html()) + 1);
              }
            }
          }

          if (item.type3 === 'L') {
            type7L.html(+(type7L.html()) + 1);
          } else if (item.type3 === 'R') {
            type7R.html(+(type7R.html()) + 1);
          }
          if (item.type2 === '인사이드') {
            type7I.html(+(type7I.html()) + 1);
          } else if (item.type2 === '아웃사이드') {
            type7O.html(+(type7O.html()) + 1);
          } else if (item.type2 === '인스텝') {
            type7IS.html(+(type7IS.html()) + 1);
          } else if (item.type2 === '발바닥') {	
            type7SO.html(+(type7SO.html()) + 1);	
          }	

           try {	
            let stride = JSON.parse(item.point);	
            stride = (stride[9] + stride[19]) / 2;	

             type7ST.html(+(type7ST.html()) + stride);	

             $('#device-stride-value').html(stride);
          } catch(e) {	
            console.log(e);	
          }
        }
      });

      span.html(count);
    });
  };
  
  vm.appContext.deviceData = [];
  
  vm.saveMeta = {
    type1: '공격', // 공격, 수비
    type2: '인사이드', // 인사이드, 아웃사이드, 인스텝
    type3: 'L', // L, R
    type4: '', // 트래핑, 패스, 킥, 슈팅, 드리블, 턴, 러닝, 워킹, 점프
    type5: 'A-HL-C' // vm.locations 의 위치 값들
  };

  vm.selectedDateRange = 2; // 조회기간 - 1: 현재, 2: 전체

  // $scope.$watch('vm.selectedDateRange', function(newVal, oldVal) {
  //   $('span.count4').html('0');
  //   $('span.type4-L').html('0');
  //   $('span.type4-R').html('0');
  //   $('span.type4-I').html('0');
  //   $('span.type4-O').html('0');
  //   $('span.type4-IS').html('0');
  //   $('span.type4-SO').html('0');
  //   $('span.type4-ST').html('0');
  //   $('span.count7').html('0');
  //   $('span.type7-L').html('0');
  //   $('span.type7-R').html('0');
  //   $('span.type7-I').html('0');
  //   $('span.type7-O').html('0');
  //   $('span.type7-IS').html('0');
  //   $('span.type7-SO').html('0');
  //   $('span.type7-ST').html('0');

  //   _.forEach(vm.categories['movement'], function(category) {
  //     _.forEach(category.items, function(item) {
  //       item.value = 0;
  //       item.left = 0;
  //       item.right = 0;
  //       item.inside = 0;
  //       item.outside = 0;
  //       item.instep = 0;
  //       item.sole = 0;
  //       item.stride = 0;
  //     });
  //   });
  // });
  
// 오늘 날짜 조회
function getCurrentDate() {
  var dateObj = new Date(),
    year = dateObj.getFullYear(),
    month = dateObj.getMonth() + 1,
    date = dateObj.getDate();

  if (month < 10) {
    month = '0' + month;
  }
  if (date < 10) {
    date = '0' + date;
  }

  return year + '-' + month + '-' + date;
}

vm.getDataByLoginId = function(from, to, all, update) {
  $('.lds-spinner')
    .css('top', document.documentElement.clientHeight / 2)
    .show();

  // 시작일이 없을 경우 오늘로 설정
  if (!from) {
    from = getCurrentDate();
  }

  // 전체보기를 할 경우 from 설정
  if (all) {
    from = '2018-01-07';
  }

  // var url = 'http://eptsdev.codns.com:7724/epts/get_data_by_login_id/' + vm.appContext.user.login_id;
  var url = 'http://eptsdev.codns.com:7724/epts/get_data_by_login_id/sgs.testuser.device@gmail.com';
  if (from) {
    url = url + '/' + from;
  }
  if (from && to) {
    url = url + '/' + to;
  }

  $.ajax({
    url: url,
    type: 'GET',
    success: function(data) {
      console.log(data);

      vm.appContext.deviceData = data;
      vm.appContext.updateType1Count();
      vm.appContext.updateType2Count();
      vm.appContext.updateType3Count();
      vm.appContext.updateType4Count();
      vm.appContext.updateType6Count();
      vm.appContext.updateType7Count();
      
      // 차트 데이터 생성 시작
      vm.selectedDeviceData = vm.appContext.deviceData;

      $('div.display-data').find('span.count4').each(function() {
        var span = $(this),
          parent = span.parent(),
          parentTagName = parent[0].tagName,
          count = 0,
          type4 = parent.data('type4');
  
        var type4L = parent.find('span.type4-L'),
          type4R = parent.find('span.type4-R'),
          type4I = parent.find('span.type4-I'),
          type4O = parent.find('span.type4-O'),
          type4IS = parent.find('span.type4-IS'),
          type4SO = parent.find('span.type4-SO'),
          type4ST = parent.find('span.type4-ST');
  
        _.each(vm.selectedDeviceData, function(item) {
          if (item.type4 === type4) {
            
            // td 내부의 span 일 경우 상위의 th 를 찾아서 count 를 더함
            if (parentTagName === 'TD') {
              var th,
                left,
                right;
              if (span.closest('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
              }
  
              if (th) {
                
                console.log(th.data('type4'), +(th.find('span.count4').html()), span.parent('td').data('type4'), +span.html());
                

                var thObj = _.find(vm.categories['movement'], {
                  title: th.data('type4')
                });
                if (!thObj) {
                  thObj = _.find(vm.categories['location'], {
                    title: th.data('type4')
                  });
                }
                if (thObj) {
                  var obj1 = _.find(thObj.items, {
                    name: th.data('type4')
                  });
                  if (obj1) {
                    obj1.value = +(th.find('span.count4').html());
                  }
                  var obj2 = _.find(thObj.items, {
                    name: (span.parent('td').text().split(' '))[0]
                  });
                  if (obj2) {
                    obj2.value = +span.html();
                  }
                }

                var obj3;
                _.forEach(vm.categories['movement'].concat(vm.categories['location']), function(category) {
                  _.forEach(category.items, function(item) {
                    if (th.data('type4') === category.title && item.name === (span.parent('td').text().split(' '))[0]) {
                      obj3 = item;
                    }
                  });
                });
                if (obj3) {
                  obj3.left = +(type4L.html());
                  obj3.right = +(type4R.html());
                  obj3.inside = +(type4I.html());
                  obj3.outside = +(type4O.html());
                  obj3.instep = +(type4IS.html());
                  obj3.sole = +(type4SO.html());
                  obj3.stride = +(type4ST.html());

                  if (typeof obj3.data === 'undefined') {
                    obj3.data = [];
                  }
                  var obj4 = _.find(obj3.data, function(dataItem) {
                    return dataItem.name === item.name && dataItem.datetime.substr(0, 16) === item.datetime.substr(0, 16);  // 날짜와 시간, 분이 같은 경우
                  });
                  if (obj4) {
                    obj4.value = obj4.value + 1;
                  } else {
                    obj3.data.push({
                      datetime: item.datetime.substr(0, 16),
                      value: 1
                    });
                  }

                  // console.log('item', item, obj3);
                }
              }
            }
          }
        });
      });

      _.each(vm.selectedDeviceData, function(item) {
        _.each(vm.categories['bio'][0].items, function(item2) {
          if (typeof item2.data === 'undefined') {
            item2.data = [];
          }

          if (item.type4 === item2.name) {
            var value;
            if (item2.name === '심박수') {
              value = item.type8;
            } else if (item2.name === '체온') {
              value = item.type9;
            } else if (item2.name === '산소포화도') {
              value = item.type10;
            } else if (item2.name === '칼로리') {
              value = item.type11;
            }

            item2.data.push({
              datetime: item.datetime.substr(0, 16),
              value: +value
            });
          }
        });
      });

      _.each(vm.selectedDeviceData, function(item) {
        _.each(vm.categories['bio'][1].items, function(item2) {
          if (typeof item2.data === 'undefined') {
            item2.data = [];
          }

          if (item.type4 === item2.name) {
            var value;
            if (item2.name === '젖산') {
              value = item.type12;
            } else if (item2.name === '폐활량') {
              value = item.type13;
            } else if (item2.name === '체중') {
              value = item.type14;
            }

            item2.data.push({
              datetime: item.datetime.substr(0, 16),
              value: +value
            });
          }
        });
      });

      _.each(vm.selectedDeviceData, function(item) {
        _.each(vm.categories['bio'][2].items, function(item2) {
          if (typeof item2.data === 'undefined') {
            item2.data = [];
          }

          if (item.type4 === item2.name) {
            var value;
            if (item2.name === '체수분') {
              value = item.type15;
            } else if (item2.name === '체지방') {
              value = item.type16;
            } else if (item2.name === '골격근') {
              value = item.type17;
            }

            item2.data.push({
              datetime: item.datetime.substr(0, 16),
              value: +value
            });
          }
        });
      });

      _.each(vm.selectedDeviceData, function(item) {
        _.each(vm.categories['bio'][3].items, function(item2) {
          if (typeof item2.data === 'undefined') {
            item2.data = [];
          }

          if (item.type4 === item2.name) {
            var value;
            if (item2.name === '혈당') {
              value = item.type18;
            } else if (item2.name === '혈압') {
              value = item.type19;
            } else if (item2.name === '단백질') {
              value = item.type20;
            }

            item2.data.push({
              datetime: item.datetime.substr(0, 16),
              value: +value
            });
          }
        });
      });


      $('div.display-data').find('span.count7').each(function() {
        var span = $(this),
          parent = span.parent(),
          parentTagName = parent[0].tagName,
          count = 0,
          type7 = parent.data('type7');

        var type7L = parent.find('span.type7-L'),
          type7R = parent.find('span.type7-R'),
          type7I = parent.find('span.type7-I'),
          type7O = parent.find('span.type7-O'),
          type7IS = parent.find('span.type7-IS'),
          type7SO = parent.find('span.type7-SO'),
          type7ST = parent.find('span.type7-ST');
  
        _.each(vm.selectedDeviceData, function(item) {
          if (item.type7 === type7 || (type7 === '워킹' && item.type4 === '워킹') || (type7 === '스프린트' && item.type4 === '스프린트') || (type7 === '러닝' && item.type4 === '러닝') || (type7 === '점프' && item.type4 === '점프') || (type7 === '턴' && item.type4 === '턴')) {
            
            // td 내부의 span 일 경우 상위의 th 를 찾아서 count 를 더함
            if (parentTagName === 'TD') {
              var th,
                left,
                right;
              if (span.closest('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
              } else if (span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th').length) {
                th = span.closest('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').prev('tr').find('th');
              }
  
              if (th) {
                
                console.log(th.data('type7'), +(th.find('span.count7').html()), span.parent('td').data('type7'), +span.html());
                
                var thObj = _.find(vm.categories['movement'], {
                  title: th.data('type7')
                });
                if (!thObj) {
                  thObj = _.find(vm.categories['location'], {
                    title: th.data('type7')
                  });
                }
                if (thObj) {
                  var obj1 = _.find(thObj.items, {
                    name: th.data('type7')
                  });
                  if (obj1) {
                    obj1.value = +(th.find('span.count7').html());
                  }
                  var obj2 = _.find(thObj.items, {
                    name: (span.parent('td').text().split(' '))[0]
                  });
                  if (obj2) {
                    obj2.value = +span.html();
                  }
                }

                var obj3;
                _.forEach(vm.categories['movement'].concat(vm.categories['location']), function(category) {
                  _.forEach(category.items, function(item) {
                    if (category.title === '활동량' || category.title === '동작') {
                      // console.log('활동량', item.name, span.parent('td').text());
                    }
                    if (th.data('type7') === category.title && item.name === (span.parent('td').text().split(' '))[0]) {
                      obj3 = item;
                    }
                  });
                });
                if (obj3) {
                  obj3.left = +(type7L.html());
                  obj3.right = +(type7R.html());
                  obj3.inside = +(type7I.html());
                  obj3.outside = +(type7O.html());
                  obj3.instep = +(type7IS.html());
                  obj3.sole = +(type7SO.html());
                  obj3.stride = +(type7ST.html());

                  if (typeof obj3.data === 'undefined') {
                    obj3.data = [];
                  }
                  var obj4 = _.find(obj3.data, function(dataItem) {
                    return dataItem.name === item.name && dataItem.datetime.substr(0, 16) === item.datetime.substr(0, 16);  // 날짜와 시간, 분이 같은 경우
                  });
                  if (obj4) {
                    obj4.value = obj4.value + 1;
                  } else {
                    obj3.data.push({
                      datetime: item.datetime.substr(0, 16),
                      value: 1
                    });
                  }

                  // console.log('item', item, obj3);
                }
              }
            }
          }
        });
      });

      _.forEach(vm.categories, function(type) {
        _.forEach(type, function(category) {
          _.forEach(category.items, function(item) {
            if (!item.value) {
              item.value = 0;
            }
            if (!item.left) {
              item.left = 0;
            }
            if (!item.right) {
              item.right = 0;
            }
            if (!item.inside) {
              item.inside = 0;
            }
            if (!item.outside) {
              item.outside = 0;
            }
            if (!item.instep) {
              item.instep = 0;
            }
            if (!item.sole) {
              item.sole = 0;
            }
            if (!item.stride) {
              item.stride = 0;
            }
          });
        });
      });
      // 차트 데이터 생성 끝

      // 차트 생성
      _.forEach(vm.categories['movement'], function(category) {
        (function(category) {
          $timeout(function() {
            // console.log(category);

            // vm.clearChart(category.title);

            vm.generateVariableRadiusChart(category);
            vm.generateMainBarChart(category);
            vm.generateHeatmap(category);
            vm.generateScatterPlot(category, false, update);
          }, 1000);
        })(category);

        _.forEach(vm.categories['bio'], function(category) {
          (function(category) {
            $timeout(function() {
              console.log(category);

              vm.generateActivityChart(category);
              vm.generateActivityText(category);
              vm.generateHeatmap(category);
              vm.generateScatterPlot(category, false, update);
            }, 1000);
          })(category);
        });

        _.forEach(vm.categories['location'], function(category) {
          (function(category) {
            $timeout(function() {
              console.log(category);

              // vm.clearChart(category.title);

              vm.generateVariableRadiusChart(category);
              vm.generateMainBarChart(category);
              vm.generateHeatmap(category);
              vm.generateScatterPlot(category, false, update);
            }, 1000);
          })(category);
        });
      });

      $('.lds-spinner').hide();
    },
    error: function(err) {
      console.log(err);
    }
  });
}

// 페이지 최초 접속시 전체 데이터 조회
vm.getDataByLoginId(false, false, true);

vm.categorySelect = function(category, item) {
  if (category.title.match('컨디션')) {
    _.forEach(category.items, function(obj) {
      if (item.name === obj.name) {
        obj.selected = true;
      } else {
        obj.selected = false;
      }

      vm.clearChart(category.title);

      // 전체 차트 생성
      if (item.title) {
        vm.generateActivityChart(category);
        vm.generateActivityText(category);
        vm.vm.generateScatterPlot(category, false);
      }
      // 개별 차트 생성
      else {
        vm.chartData[category.title].showMain = false;
        // vm.generateBioBarChart(category, item);
        vm.generateActivityChart2(category, item);
        vm.generateActivityText2(category, item);
        vm.generateScatterPlot(category, item);
      }
    });
  } else {
    _.forEach(category.items, function(obj) {
      if (item.name === obj.name) {
        obj.selected = true;
      } else {
        obj.selected = false;
      }

      vm.clearChart(category.title);

      // 전체 차트 생성
      if (item.title) {
        vm.generateVariableRadiusChart(category);
        vm.generateMainBarChart(category);
        vm.generateHeatmap(category);
        vm.generateScatterPlot(category, false);
      }
      // 개별 차트 생성
      else {
        vm.chartData[category.title].showMain = false;
        vm.generateBarChart(category, item);
        vm.generateHeatmap(category);
        vm.generateScatterPlot(category, item);
      }
    });
  }
};

vm.clearChart = function(title) {
  let targetId = '#' + title + '-chart';
  $(targetId).html('');
  let targetId2 = '#' + title + '-chart2';
  $(targetId2).html('');
  let targetId3 = '#' + title + '-chart3';
  $(targetId3).html('');
};

vm.chartData = {};

vm.generateVariableRadiusChart = function(category) {
  let options = {
    containerId: category.title + '-chart',
    width: 200,
    height: 150
  };

  let data = {
    showMain: true
  };
  vm.chartData[category.title] = data;

  ChartGeneratorService.generateVariableRadiusChart(options, category);
};

vm.generateActivityChart = function(category) {
  let options = {
    containerId: category.title + '-chart',
    width: 200,
    height: 136
  };

  let data = {
    showMain: true
  };
  vm.chartData[category.title] = data;

  ChartGeneratorService.generateActivityChart(options, category);
};

vm.generateActivityText = function(category) {
  let containerId = category.title + '-chart3';

  let html;

  if (category.title === '컨디션') {
    html = '<span style="display:block; margin-top:20px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">심박수</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value1" style="font-weight:normal; font-size:12px;">0</span> bpm</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">체온</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value3" style="font-weight:normal; font-size:12px;">0</span> ℃</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">산소포화도</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value2" style="font-weight:normal; font-size:12px;">0</span> %</span></span>';
  } else if (category.title === '컨디션2') {
    html = '<span style="display:block; margin-top:20px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">젖산</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;">0 mg/dl</span></span>';
  html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">폐활량</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;">0 ml</span></span>';
  html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">체중</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;">0 kg</span></span>';
  } else if (category.title === '컨디션3') {
    html = '<span style="display:block; margin-top:20px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">체수분</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;">0 l</span></span>';
  html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">체지방</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;">0 kg</span></span>';
  html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">골격근</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;">0 km</span></span>';
  } else if (category.title === '컨디션4') {
    html = '<span style="display:block; margin-top:20px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">혈당</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;">0 mg</span></span>';
  html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">혈압</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;">0 mmHg</span></span>';
  html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">단백질</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;">0 %</span></span>';
  }

  $('#' + containerId).html(html);
};

vm.generateActivityChart2 = function(category, item) {
  let options = {
    containerId: category.title + '-chart2',
    width: 200,
    height: 136
  };

  let data = {
    showMain: false
  };
  vm.chartData[category.title] = data;

  ChartGeneratorService.generateActivityChart(options, category, item);
};

vm.generateActivityText2 = function(category, item) {
  let containerId = category.title + '-chart4';

  // 심박수 - data40
  // 체온 - data42
  // 산소포화도 - data41

  var unit;
  if (item.name === '심박수') {
    unit = 'bpm';
  } else if (item.name === '체온') {
    unit = '℃';
  } else if (item.name === '산소포화도') {
    unit = '%';
  } else if (item.name === '젖산') {
    unit = 'mg/dl';
  } else if (item.name === '폐활량') {
    unit = 'ml';
  } else if (item.name === '체중') {
    unit = 'kg';
  } else if (item.name === '체수분') {
    unit = 'l';
  } else if (item.name === '체지방') {
    unit = 'kg';
  } else if (item.name === '골격근') {
    unit = 'kg';
  } else if (item.name === '혈당') {
    unit = 'mg';
  } else if (item.name === '혈압') {
    unit = 'mmHg';
  } else if (item.name === '단백질') {
    unit = '%';
  } else if (item.name === '칼로리') {
    unit = 'kcal';
  }

  let html = '<span style="display:block; margin-top:10px; color:#fff; font-size:12px; text-align:center;">최대<span style="margin-left:16px; font-weight:bold; font-size:16px; text-align:center;">0' + unit + '</span></span>';
  html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:center;">안정<span style="margin-left:16px; font-weight:bold; font-size:16px; text-align:center;">0' + unit + '</span></span>';
  html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:center;">회복<span style="margin-left:16px; font-weight:bold; font-size:16px; text-align:center;">0' + unit + '</span></span>';
  html += '<span style="display:block; margin-top:7px; color:#fff; font-size:12px; text-align:center;">위험<span style="margin-left:16px; font-weight:bold; font-size:16px; text-align:center;">0' + unit + '</span></span>';

  $('#' + containerId).html(html);
};

vm.generateLiquidChart = function(category) {
  let value = parseInt(Math.random() * 100, 10);
  let max = 100;

  let targetId = '#' + category.title + '-chart';
  $(targetId).html('');

  //liquid gauge chart
  let options = ChartGeneratorService.getLiquidGaugeOptions();
  options.displayPercent = false;
  options.targetId = targetId;
  options.svgId = 'water-liquid';
  options.circleColor = '#3187c5';
  options.textColor = '#3187c5';
  options.waveColor = '#3187c5';
  options.size = liquidGaugeSize;
  let dataValue = value / max * 100;
  ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);

  let data = {
    title: '',
    value: number_format(value),
    unit: '',
    showMain: true
  };
  vm.chartData[category.title] = data;
};

vm.generateMainBarChart = function(category) {
  // 값 표시
  if (category.title === '동작') {
    let containerId = category.title + '-chart3';

    let html;

    let count = 0;
    console.log('동작', category);
    _.forEach(category.items, function(item) {
      if (item.name !== '동작') {
        count += item.value;
      }
    });

    if (vm.appContext.isIOS) {
      html = '<div style="overflow:hidden;"><div style="width:100px; float:right;><div style="text-align:left;">';
      html += '<span style="display:block; margin-top:20px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">횟수</span><br><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span style="font-weight:normal; font-size:12px;">' + count + '</span> set</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">가속도</span><br><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value8" style="font-weight:normal; font-size:12px;">0</span> km</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">속도</span><br><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value6" style="font-weight:normal; font-size:12px;">0</span> km</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">거리</span><br><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value9" style="font-weight:normal; font-size:12px;">0</span> km</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">시간</span><br><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:12px;">0</span> min</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">칼로리</span><br><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:12px;">0</span> kcal</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">보폭</span><br><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="device-stride-value" style="font-weight:normal; font-size:12px;">0</span> cm</span></span>';
      html += '</div></div></div>';
    } else {
      html = '<span style="display:block; margin-top:20px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">횟수</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span style="font-weight:normal; font-size:12px;">' + count + '</span> set</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">가속도</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value8" style="font-weight:normal; font-size:12px;">0</span> km</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">속도</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value6" style="font-weight:normal; font-size:12px;">0</span> km</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">거리</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value9" style="font-weight:normal; font-size:12px;">0</span> km</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">시간</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:12px;">0</span> min</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">칼로리</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:12px;">0</span> kcal</span></span>';
      html += '<span style="display:block; margin-top:1px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">보폭</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="device-stride-value" style="font-weight:normal; font-size:12px;">0</span> cm</span></span>';
    }
    $('#' + containerId).html(html);
  }
  // 바차트
  else {
    let item = {
      name: '전체'
    };

    let total = {
      left: 0,
      right: 0,
      inside: 0,
      outside: 0,
      instep: 0,
      sole: 0,
      stride: 0,
      value: 0
    };

    _.forEach(category.items, function(item) {
      total.left += item.left;
      total.right += item.right;
      total.inside += item.inside;
      total.outside += item.outside;
      total.instep += item.instep;
      total.sole += item.sole;
      total.stride += item.stride;
      total.value += item.value;
    });

    // if (total.left === 0 && total.right === 0 && total.inside === 0 && total.outside === 0 && total.instep === 0) {
    //   return;
    // }

    let left = total.left;
    let right = total.right;
    let inside = total.inside;
    let outside = total.outside;
    let instep = total.instep;
    let sole = total.sole;
    let stride = total.stride;
    let value = total.value;
    stride = (value === 0) ? 0 : stride / value;
    console.log(category.items, left, right);
    let data = {
      name: item.name,
      left: left,
      right: right,
      inside: inside,
      outside: outside,
      instep: instep,
      sole: sole,
      stride: stride
    };
    vm.playerSkillData = data;
    let targetId = '#' + category.title + '-chart3';

    $(targetId).html('');

    let performanceTitles = ['활동량', '동작'];

    let dataset;
    if (performanceTitles.indexOf(category.title) > -1) {
      dataset = [{
        data: [{
            title: '횟수',
            count: 0
          },{
            title: '가속도',
            count: 0
          },{
            title: '속도',
            count: 0
          },
          {
            title: '거리',
            count: 0
          },
          {
            title: '시간',
            count: 0
          },
          {
            title: '칼로리',
            count: 0
          },{
            title: '보폭',
            count: 0
          }
        ]}
      ];
    } else {
      dataset = [{
        data: [{
            title: '왼발',
            count: left
          },
          {
            title: '오른발',
            count: right
          },
          {
            title: '인사이드',
            count: inside
          },
          {
            title: '아웃사이드',
            count: outside
          },{
            title: '인스텝',
            count: instep
          },{
            title: '발바닥',
            count: sole
          },{
            title: '보폭',
            count: stride
          }
        ]}
      ];  
    }
    // console.log('dataset', dataset);
    ChartGeneratorService.createStackedBarChartHoriz(targetId, dataset);
  }
};

vm.generateBarChart = function(category, item) {
  // 값 표시
  if (category.title === '동작') {
    let containerId = category.title + '-chart2';

    let html;

    let count = item.value;

    html = '<span style="display:block; margin-top:20px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">횟수</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span style="font-weight:normal; font-size:12px;">' + count + '</span> set</span></span>';
    html += '<span style="display:block; margin-top:5px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">가속도</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value8" style="font-weight:normal; font-size:12px;">0</span> km</span></span>';
    html += '<span style="display:block; margin-top:5px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">속도</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value6" style="font-weight:normal; font-size:12px;">0</span> km</span></span>';
    html += '<span style="display:block; margin-top:5px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">거리</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="item40value9" style="font-weight:normal; font-size:12px;">0</span> km</span></span>';
    html += '<span style="display:block; margin-top:5px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">시간</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:12px;">0</span> min</span></span>';
    html += '<span style="display:block; margin-top:5px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">칼로리</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:12px;">0</span> kcal</span></span>';
    html += '<span style="display:block; margin-top:5px; color:#fff; font-size:12px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">보폭</span><span style="margin-left:16px; font-weight:normal; font-size:12px; text-align:left; margin-left:10px;"><span id="device-stride-value" style="font-weight:normal; font-size:12px;">0</span> cm</span></span>';
    $('#' + containerId).html(html);
  }
  // 바차트
  else {
    let left = item.left;
    let right = item.right;
    let inside = item.inside;
    let outside = item.outside;
    let instep = item.instep;
    let sole = item.sole;
    let stride = item.stride;
    let value = item.value;
    stride = (value === 0) ? 0 : stride / value;
    
    let data = {
      name: item.name,
      left: left,
      right: right,
      inside: inside,
      outside: outside,
      instep: instep,
      sole: sole,
      stride: stride
    };
    vm.playerSkillData = data;
    let targetId = '#' + category.title + '-chart2';

    $(targetId).html('');

    let performanceTitles = ['활동량', '동작'];

    let dataset;
    if (performanceTitles.indexOf(category.title) > -1) {
      dataset = [{
        data: [{
            title: '횟수',
            count: 0
          },{
            title: '가속도',
            count: 0
          } ,{
            title: '속도',
            count: 0
          },
          {
            title: '거리',
            count: 0
          },
          {
            title: '시간',
            count: 0
          },
          {
            title: '칼로리',
            count: 0
          },{
            title: '보폭',
            count: 0
          }
        ]}
      ];
    } else {
      dataset = [{
        data: [{
            title: '왼발',
            count: left
          },
          {
            title: '오른발',
            count: right
          },
          {
            title: '인사이드',
            count: inside
          },
          {
            title: '아웃사이드',
            count: outside
          },{
            title: '인스텝',
            count: instep
          },{
            title: '발바닥',
            count: sole
          },{
            title: '보폭',
            count: stride
          }
        ]}
      ];  
    }
    console.log('dataset', dataset);

    vm.chartData[category.title].detail = data;

    ChartGeneratorService.createStackedBarChartHoriz(targetId, dataset);
  }
};

vm.generateBioBarChart = function(category, item) {
  let max = Math.random() * 100;
  let stable = Math.random() * 100;
  let recovery = Math.random() * 100;
  let danger = Math.random() * 100;
  
  let data = {
    name: item.name,
    max: max,
    stable: stable,
    recovery: recovery,
    danger: danger
  };
  vm.playerSkillData = data;
  let targetId = '#' + category.title + '-chart2';

  $(targetId).html('');

  let performanceTitles = ['활동량', '동작'];

  let dataset;
  if (performanceTitles.indexOf(category.title) > -1) {
    dataset = [{
      data: [{
          title: '속도',
          count: 0
        },
        {
          title: '거리',
          count: 0
        },
        {
          title: '시간',
          count: 0
        },
        {
          title: '칼로리',
          count: 0
        },{
          title: '보폭',
          count: 0
        }
      ]}
    ];
  } else {
    dataset = [{
      data: [{
          title: '왼발',
          count: left
        },
        {
          title: '오른발',
          count: right
        },
        {
          title: '인사이드',
          count: inside
        },
        {
          title: '아웃사이드',
          count: outside
        },{
          title: '인스텝',
          count: instep
        },{
          title: '발바닥',
          count: sole
        },{
          title: '보폭',
          count: stride
        }
      ]}
    ];  
  }
  console.log('dataset', dataset);

  vm.chartData[category.title].detail = data;

  ChartGeneratorService.createStackedBarChartHoriz(targetId, dataset);
};

vm.generateHeatmap = function(category) {
  let heatmapInstance;

  let targetId = '#' + category.title + '-heatmap';
  
  if (!$(targetId).length) {
    return;
  }
  
  let points = [];

  var heatmapContainerParent = $(targetId).closest('.w3-display-container'),
    // heatmapWidth = heatmapContainerParent.width(),
    heatmapWidth = document.body.clientWidth - 64,
    heatmapHeight = heatmapContainerParent.height();
    
  $(targetId)
    .width(heatmapWidth)
    .height(heatmapHeight);
  var heatmapRadius = 30;

  AnalysisService.getLocationList()
  .then(function (res) {
    let locations = res.data.data;

    _.forEach(locations, function (o) {
      var targetObj = EventAnalysisService.getPosition(heatmapWidth, heatmapHeight, o.abbr);
      targetObj.radius = heatmapRadius;
      // console.log('targetObj 000....', targetObj);

      // 실제 측정기록 데이터로 히트맵 그리기용 데이터 생성
      var type5Data = _.filter(vm.appContext.deviceData, {
        type5: o.abbr
      });

      if (targetObj) {
        // 실제 데이터
        targetObj['value'] = type5Data.length;

        // 임시데이터 삽입
        // targetObj['value'] = Math.floor((Math.random() * 100) + 1);
        // console.log('targetObj 111....', targetObj);
        points.push(targetObj);
      }
    });

    $(targetId).empty();

    heatmapInstance = h337.create({
      container: document.querySelector(targetId)
    });

    let locationData = {
      max: 100,
      // width : 100,
      // height : 200,
      data: points
    };
    heatmapInstance.removeData();
    heatmapInstance.setData(locationData);
  }).catch(function (e) {
    console.log('ERROR ' + e);
  });
};

vm.generateScatterPlot = function(category, item, update) {
  // console.log('scatter', vm.appContext.deviceData, category);

  let options = {
    containerId: category.title + '-scatter'
  };

  ChartGeneratorService.createScatterPlot(options, category, item, update);
};





















  // 우측 1번째 영역 차트 그리기 함수
  vm.displaySkillData = function () {

    let targetId = '#player-skill-main-chart';
    let target = $(targetId);
    target.html('');
    let margins = {
      top: 10,
      left: 50,
      right: 20,
      bottom: 0
    };


    var dataset = [{
      data: [{
        title: "시도",
        count: vm.movement.att
      }, {
        title: "성공",
        count: vm.movement.suc
      }]
    }]

    ChartGeneratorService.createStackedBarChartHoriz(targetId, dataset, target.width(), target.height(), margins);
  };


  vm.game = function () {

    if (vm.user_id === undefined || !vm.result) {
      return;
    }
    var data = {
      login_id: vm.appContext.user.login_id,
      game_id: $stateParams.id,
      period: vm.period,
    }
    var movement = vm.result.movements[vm.indexA].name;
    if (movement == '공격') {
      data.type = 'O';
    } else if (movement == '수비') {
      data.type = 'D';
    } else if (movement == '왼발') {
      data.type = 'L';
    } else if (movement == '오른발') {
      data.type = 'R';
    } else {
      data.movement_id = vm.result.movements[vm.indexA].id;
    }

    var arr = vm.appContext.players.game.my_team.entryMain
      .concat(vm.appContext.players.game.my_team.entryBackup)
      .concat(vm.appContext.players.game.oppo_team.entryMain)
      .concat(vm.appContext.players.game.oppo_team.entryBackup);
    if (vm.appContext.selectedType === 'player') {
      var user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
      data.user_id = user_id;
    } else {
      data.team_id = vm.appContext.selectedTeamId
      var user_id = _.map(arr, 'user_id');
    }

    if (vm.secondOrPeriod === 'period') {
      AnalysisService.game(data)
        .then(function (res) {console.log('res data', res.data.data);
          var chartData = [];
          _.forEach(res.data.data, function (item) {
            chartData.push([item.sec, item.att]);
          });

          // analysis 앱 데이터 조회
          AnalysisService.getPlayersPredictionData({
            from: vm.date.replace(/\./g, '-'),
            to: vm.date.replace(/\./g, '-'),
            user_ids: JSON.stringify(user_id)
          }).then(function(res2) {
            var analysisData = res2.data;

              _.forEach(analysisData, function(item2) {
                var timestamp = +(new Date(item2.datetime)),
                  startTimestamp = +(new Date(vm.info.date + ' ' + vm.info.first_start)),
                  sec = (timestamp - startTimestamp) / 1000;
                  
                _.forEach(chartData, function(dataItem, i) {
                  if (dataItem[0] == sec) {
                    chartData[i][1] = chartData[i][1] + 1;

                    if (data.movement_id) {
                      if (item2.type4 == vm.result.movements[vm.indexA].name) {
                        vm.result.movements[vm.indexA].suc++;
                        vm.result.movements[vm.indexA].att++;
                      }
                    } else {
                      if (movement === '공격') {
                        if (item2.type1 == '공격') {
                          vm.result.movements[vm.indexA].suc++;
                          vm.result.movements[vm.indexA].att++;
                        }
                      } else if (movement === '수비') {
                        if (item2.type1 == '수비') {
                          vm.result.movements[vm.indexA].suc++;
                          vm.result.movements[vm.indexA].att++;
                        }
                      } else if (movement === '왼발') {
                        if (item2.type3 == 'L') {
                          vm.result.movements[vm.indexA].suc++;
                          vm.result.movements[vm.indexA].att++;
                        }
                      } else if (movement === '오른발') {
                        if (item2.type3 == 'R') {
                          vm.result.movements[vm.indexA].suc++;
                          vm.result.movements[vm.indexA].att++;
                        }
                      }
                    }
                  }
                });
              });

              // 차트 데이터 생성
              vm.chartConfig.series[0].data = chartData;

          }).catch(function(err) {
            console.log(err);
          });
        })
        .catch(function (error) {
          console.log("An error occured : " + JSON.stringify(error));
        });
    }

    vm.detailHeatmapA()
    vm.detailMovementB()
    vm.detailBioC()
    vm.detailBioD()

  }

  vm.detailHeatmapA = function () {

    console.log('vm.period', vm.period)

    var data = {
      login_id: vm.appContext.user.login_id,
      game_id: $stateParams.id,
    }

    var movement = vm.result.movements[vm.indexA].name;
    if (movement == '공격') {
      data.type = 'O';
    } else if (movement == '수비') {
      data.type = 'D';
    } else if (movement == '왼발') {
      data.type = 'L';
    } else if (movement == '오른발') {
      data.type = 'R';
    } else {
      data.movement_id = vm.result.movements[vm.indexA].id;
    }

    var arr = vm.appContext.players.game.my_team.entryMain
      .concat(vm.appContext.players.game.my_team.entryBackup)
      .concat(vm.appContext.players.game.oppo_team.entryMain)
      .concat(vm.appContext.players.game.oppo_team.entryBackup);
    if (vm.appContext.selectedType === 'player') {
      var user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
      data.user_id = user_id;
    } else {
      data.team_id = vm.appContext.selectedTeamId
      var user_id = _.map(arr, 'user_id');
    }

    if (vm.secondOrPeriod === 'period') {
      data.period = vm.period;
      AnalysisService.game(data)
        .then(function (res) {
          var width = document.getElementById('analysis-heatmap-bg').clientWidth;
          var height = document.getElementById('analysis-heatmap-bg').clientHeight;
          var points = [];
          _.forEach(res.data.locations, function (loc) {
            var obj = _.find(vm.locations, {
              id: loc.id
            });
            var position = EventAnalysisService.getPosition(width, height, obj.abbr);
            points.push({
              x: position.x,
              y: position.y,
              value: loc.att,
              abbr: obj.abbr
            });
          })

          // analysis 앱 데이터 조회
          AnalysisService.getPlayersPredictionData({
            from: vm.date.replace(/\./g, '-'),
            to: vm.date.replace(/\./g, '-'),
            user_ids: JSON.stringify(user_id)
          }).then(function(res2) {
            var analysisData = res2.data;

              _.forEach(analysisData, function(item) {
                var obj = _.find(points, {
                  abbr: item.abbr
                });
                
                if (obj) {
                  obj.value++;
                } else {
                  var position = EventAnalysisService.getPosition(width, height, item.abbr);
                  points.push({
                    x: position.x,
                    y: position.y,
                    value: 1,
                    abbr: item.abbr
                  });
                }
              });

              // 차트 생성
              drawHeatmap(height, points);

          }).catch(function(err) {
            console.log(err);
          });
          
        })
        .catch(function (error) {
          console.log('ERROR.........', error)
        });
    } else {
      data.sec = vm.second;
      AnalysisService.gameDetail(data)
        .then(function (res) {
          var width = document.getElementById('analysis-heatmap-bg').clientWidth;
          var height = document.getElementById('analysis-heatmap-bg').clientHeight;
          var points = [];
          _.forEach(res.data.locations, function (loc) {
            var obj = _.find(vm.locations, {
              id: loc.id
            });
            var position = EventAnalysisService.getPosition(width, height, obj.abbr);
            points.push({
              x: position.x,
              y: position.y,
              value: loc.att
            });
          })
          drawHeatmap(height, points);
        })
        .catch(function (error) {
          console.log('ERROR.........', error)
        });
    }

    console.log('detailHeatmapA', data)


  }

  vm.detailMovementB = function (mode) {
    if (!vm.result) {
      return;
    }
    var data = {
      login_id: vm.appContext.user.login_id,
      game_id: $stateParams.id,
    }
    var movement = vm.result.movements[vm.indexB].name;
    if (movement == '공격') {
      data.type = 'O';
    } else if (movement == '수비') {
      data.type = 'D';
    } else if (movement == '왼발') {
      data.type = 'L';
    } else if (movement == '오른발') {
      data.type = 'R';
    } else {
      data.movement_id = vm.result.movements[vm.indexB].id;
    }

    var arr = vm.appContext.players.game.my_team.entryMain
      .concat(vm.appContext.players.game.my_team.entryBackup)
      .concat(vm.appContext.players.game.oppo_team.entryMain)
      .concat(vm.appContext.players.game.oppo_team.entryBackup);
    if (vm.appContext.selectedType === 'player') {
      
      var user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
      data.user_id = user_id;
    } else {
      data.team_id = vm.appContext.selectedTeamId
      var user_id = _.map(arr, 'user_id');
    }

    if (vm.secondOrPeriod === 'period') {
      data.period = vm.period;
      AnalysisService.game(data)
        .then(function (res) {

          vm.result.movements[vm.indexB].suc = res.data.suc;
          vm.result.movements[vm.indexB].att = res.data.att;

          // analysis 앱 데이터 조회
          AnalysisService.getPlayersPredictionData({
            from: vm.date.replace(/\./g, '-'),
            to: vm.date.replace(/\./g, '-'),
            user_ids: JSON.stringify(user_id)
          }).then(function(res2) {
            var analysisData = res2.data;

            _.forEach(analysisData, function(item) {
              var timestamp = +(new Date(item.datetime)),
                startTimestamp = +(new Date(vm.info.date + ' ' + vm.info.first_start)),
                sec = (timestamp - startTimestamp) / 1000;

              if (data.movement_id) {
                _.forEach(data, function(dataItem) {
                  if (dataItem[0] == sec && item.type4 == vm.result.movements[vm.indexB].name) {
                    dataItem = [dataItem[0], dataItem[1] + 1];
                    vm.result.movements[vm.indexB].suc++;
                    vm.result.movements[vm.indexB].att++;
                  }
                });
              } else {
                if (movement === '공격') {
                  _.forEach(data, function(dataItem) {
                    if (dataItem[0] == sec && item.type1 == '공격') {
                      dataItem = [dataItem[0], dataItem[1] + 1];
                      vm.result.movements[vm.indexB].suc++;
                      vm.result.movements[vm.indexB].att++;
                    }
                  });
                } else if (movement === '수비') {
                  _.forEach(data, function(dataItem) {
                    if (dataItem[0] == sec && item.type1 == '수비') {
                      dataItem = [dataItem[0], dataItem[1] + 1];
                      vm.result.movements[vm.indexB].suc++;
                      vm.result.movements[vm.indexB].att++;
                    }
                  });
                } else if (movement === '왼발') {
                  _.forEach(data, function(dataItem) {
                    if (dataItem[0] == sec && item.type3 == 'L') {
                      dataItem = [dataItem[0], dataItem[1] + 1];
                      vm.result.movements[vm.indexB].suc++;
                      vm.result.movements[vm.indexB].att++;
                    }
                  });
                } else if (movement === '오른발') {
                  _.forEach(data, function(dataItem) {
                    if (dataItem[0] == sec && item.type3 == 'R') {
                      dataItem = [dataItem[0], dataItem[1] + 1];
                      vm.result.movements[vm.indexB].suc++;
                      vm.result.movements[vm.indexB].att++;
                    }
                  });
                }
              }
            });

            // 차트 데이터 생성
            vm.movement = {
              att: vm.result.movements[vm.indexB].att,
              suc: vm.result.movements[vm.indexB].suc,
              ratio: (vm.result.movements[vm.indexB].att ? (vm.result.movements[vm.indexB].suc) / (vm.result.movements[vm.indexB].att) * 100 : 0)
            }
            // 차트 생성
            vm.displaySkillData();

          }).catch(function(err) {
            console.log(err);
          });

        })
        .catch(function (error) {
          console.log('ERROR.........', error)
        });
    } else {
      data.sec = vm.second;
      AnalysisService.gameDetail(data)
        .then(function (res) {
          
          // analysis 앱 데이터 조회
          AnalysisService.getPlayersPredictionData({
            from: vm.date.replace(/\./g, '-'),
            to: vm.date.replace(/\./g, '-'),
            user_ids: JSON.stringify(user_id)
          }).then(function(res2) {
            var analysisData = res2.data;

            // 차트 데이터 생성
            vm.movement = {
              att: res.data.att + analysisData.length,
              suc: res.data.suc + analysisData.length,
              ratio: (res.data.suc + analysisData.length) / (res.data.att + analysisData.length)
            }
            // 차트 생성
            vm.displaySkillData();

          }).catch(function(err) {
            console.log(err);
          });
          
        })
        .catch(function (error) {
          console.log('ERROR.........', error)
        });
    }

  }

  vm.detailBioC = function (mode) {

    if (!vm.result) {
      return;
    }
    var data = {
      login_id: vm.appContext.user.login_id,
      game_id: $stateParams.id,
    }
    data.bio_type = vm.categories_C[vm.indexC];

    // var movement = vm.result.movements[vm.indexB].name;

    // // return;

    // if (movement == '공격') {
    //   data.type = 'O';
    // } else if (movement == '수비') {
    //   data.type = 'D';
    // } else if (movement == '왼발') {
    //   data.type = 'L';
    // } else if (movement == '오른발') {
    //   data.type = 'R';
    // } else {
    //   data.movement_id = vm.result.movements[vm.indexB].id;
    // }

    if (vm.appContext.selectedType === 'player') {
      var arr = vm.appContext.players.game.my_team.entryMain
        .concat(vm.appContext.players.game.my_team.entryBackup)
        .concat(vm.appContext.players.game.oppo_team.entryMain)
        .concat(vm.appContext.players.game.oppo_team.entryBackup);
      var user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
      data.user_id = user_id;
    } else {
      data.team_id = vm.appContext.selectedTeamId
    }

    if (vm.secondOrPeriod === 'period') {
      data.period = vm.period;
      AnalysisService.game(data)
        .then(function (res) {
          console.log('cccc >>>>> ', res.data)
          vm.bioDataC = {
            max: res.data.max ? Number(res.data.max) : 0,
            average: res.data.average ? Number(res.data.max) : 0,
            target: res.data.target ? Number(res.data.max) : 0,
            min: res.data.min ? Number(res.data.max) : 0,
            stable: res.data.stable ? Number(res.data.max) : 0,
            recovery: res.data.recovery ? Number(res.data.max) : 0,
            current: res.data.current ? Number(res.data.current) : 0,
            reach: res.data.reach ? Number(res.data.reach) : 0,
          }
          vm.bioSub_C();

        })
        .catch(function (error) {
          console.log('ERROR.........', error)
        });
    } else {
      data.sec = vm.second;
      AnalysisService.gameDetail(data)
        .then(function (res) {
          console.log('cccc >>>>> ', res.data)
          vm.bioDataC = {
            max: res.data.max ? Number(res.data.max) : 0,
            average: res.data.average ? Number(res.data.max) : 0,
            target: res.data.target ? Number(res.data.max) : 0,
            min: res.data.min ? Number(res.data.max) : 0,
            stable: res.data.stable ? Number(res.data.max) : 0,
            recovery: res.data.recovery ? Number(res.data.max) : 0,
            current: res.data.current ? Number(res.data.current) : 0,
            reach: res.data.reach ? Number(res.data.reach) : 0,
          }
          vm.bioSub_C();
        })
        .catch(function (error) {
          console.log('ERROR.........', error)
        });
    }


  }

  vm.bioSub_C = function () {

    console.log('vm.sub_C', vm.sub_C, 'vm.indexC', vm.indexC, 'vm.categories_C[vm.indexC]', vm.categories_C[vm.indexC]);

    // vm.categories_C = ['HB', 'OS', 'LA', 'BT'];
    // vm.categories_D = ['DS', 'VL', 'CL', 'BW', 'IJ'];

    // vm.setHeartbeatInfo('current'); //heartbeat
    // vm.setVelocityInfo('current'); //velocity
    // vm.setOxygenInfo('current'); //Sp02
    // vm.setCaloryBurnInfo('current'); //calory_burn
    // vm.setCaloryGetInfo('current'); //caloryGet
    // vm.setLacticInfo('current'); //lactic
    // // vm.setMovementsInfo('current');        //movements
    // vm.setWeightInfo('current'); //weight
    // vm.setTemperatureInfo('current'); //temperature
    // vm.setSleepInfo('current'); //sleep
    // vm.setWaterInfo('current'); //water
    // // vm.setLocationInfo('current');         //location
    // vm.setDistanceInfo('current'); //distance


    switch (vm.categories_C[vm.indexC]) {
      case 'HB':
        vm.setHeartbeatInfo(vm.sub_C);
        break;
      case 'OS':
        vm.setOxygenInfo(vm.sub_C);
        break;
      case 'LA':
        vm.setLacticInfo(vm.sub_C);
        break;
      case 'BT':
        vm.setTemperatureInfo(vm.sub_C);
        break;
    }
  }





  vm.detailBioD = function (mode) {
    if (!vm.result) {
      return;
    }
    var data = {
      login_id: vm.appContext.user.login_id,
      game_id: $stateParams.id,
    }
    data.bio_type = vm.categories_D[vm.indexD];
    if (vm.appContext.selectedType === 'player') {
      var arr = vm.appContext.players.game.my_team.entryMain
        .concat(vm.appContext.players.game.my_team.entryBackup)
        .concat(vm.appContext.players.game.oppo_team.entryMain)
        .concat(vm.appContext.players.game.oppo_team.entryBackup);
      var user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
      data.user_id = user_id;
    } else {
      data.team_id = vm.appContext.selectedTeamId
    }

    if (vm.secondOrPeriod === 'period') {
      data.period = vm.period;
      AnalysisService.game(data)
        .then(function (res) {
          // vm.bioDataD = {
          //   max: res.data.max,
          //   average: res.data.average,
          //   target: res.data.target,
          //   injury: res.data.injury,
          //   min: res.data.min,
          //   stable: res.data.stable,
          //   recovery: res.data.recovery,
          // }

          // switch (data.bio_type) {
          //   case 'IJ':
          //     vm.setInjuryInfo('현재'); //injury
          //     break;
          // }

          if (data.bio_type === 'IJ') {
            vm.bioDataD = {
              injury: res.data.injury
            }

          } else {
            vm.bioDataD = {
              max: res.data.max ? Number(res.data.max) : 0,
              average: res.data.average ? Number(res.data.max) : 30,
              target: res.data.target ? Number(res.data.max) : 0,
              min: res.data.min ? Number(res.data.max) : 0,
              stable: res.data.stable ? Number(res.data.max) : 0,
              recovery: res.data.recovery ? Number(res.data.max) : 0,

              current: res.data.current ? Number(res.data.current) : 0,
              reach: res.data.reach ? Number(res.data.reach) : 0,
            }

          }

          vm.bioSub_D();



        })
        .catch(function (error) {
          console.log('ERROR.........', error)
        });
    } else {
      data.sec = vm.second;
      AnalysisService.gameDetail(data)
        .then(function (res) {
          // vm.bioDataD = {
          //   max: res.data.max,
          //   average: res.data.average,
          //   target: res.data.target,
          //   injury: res.data.injury,
          //   min: res.data.min,
          //   stable: res.data.stable,
          //   recovery: res.data.recovery,
          // }

          // switch (data.bio_type) {
          //   case 'IJ':
          //     vm.setInjuryInfo('현재'); //injury
          //     break;
          // }

          if (data.bio_type === 'IJ') {
            vm.bioDataD = {
              injury: res.data.injury
            }

          } else {
            vm.bioDataD = {
              max: res.data.max ? Number(res.data.max) : 0,
              average: res.data.average ? Number(res.data.max) : 30,
              target: res.data.target ? Number(res.data.max) : 0,
              min: res.data.min ? Number(res.data.max) : 0,
              stable: res.data.stable ? Number(res.data.max) : 0,
              recovery: res.data.recovery ? Number(res.data.max) : 0,

              current: res.data.current ? Number(res.data.current) : 0,
              reach: res.data.reach ? Number(res.data.reach) : 0,
            }

          }

          vm.bioSub_D();



        })
        .catch(function (error) {
          console.log('ERROR.........', error)
        });
    }


  }


  vm.bioSub_D = function () {

    console.log('vm.sub_D', vm.sub_D, 'vm.indexD', vm.indexC, 'vm.categories_D[vm.indexD]', vm.categories_D[vm.indexD]);

    // vm.categories_C = ['HB', 'OS', 'LA', 'BT'];
    // vm.categories_D = ['DS', 'VL', 'CL', 'BW', 'IJ'];

    // vm.setHeartbeatInfo('current'); //heartbeat
    // vm.setVelocityInfo('current'); //velocity
    // vm.setOxygenInfo('current'); //Sp02
    // vm.setCaloryBurnInfo('current'); //calory_burn
    // vm.setCaloryGetInfo('current'); //caloryGet
    // vm.setLacticInfo('current'); //lactic
    // // vm.setMovementsInfo('current');        //movements
    // vm.setWeightInfo('current'); //weight
    // vm.setTemperatureInfo('current'); //temperature
    // vm.setSleepInfo('current'); //sleep
    // vm.setWaterInfo('current'); //water
    // // vm.setLocationInfo('current');         //location
    // vm.setDistanceInfo('current'); //distance


    switch (vm.categories_D[vm.indexD]) {
      case 'DS':
        vm.setDistanceInfo(vm.sub_D);
        break;
      case 'VL':
        vm.setVelocityInfo(vm.sub_D);
        break;
      case 'CL':
        vm.setCaloryBurnInfo(vm.sub_D);
        break;
      case 'BW':
        vm.setWeightInfo(vm.sub_D);
        break;
      case 'IJ':
        vm.setInjuryInfo(vm.sub_D);
        break;
    }
  }








  vm.appContext.selectedType = 'team';
  vm.appContext.selectTeamCode = 'my_team';


  $scope.$watch('vm.appContext.my_team.team_id', function (newVal, oldVal) {
    if (newVal) {
      vm.appContext.selectedTeamId = vm.appContext.my_team.team_id;
    }
  })

  //selectedTime
  $scope.$watch('vm.second', function (newVal, oldVal) {
    if (newVal != undefined) {
      vm.game();
    }
  }, true)

  $scope.$watch('vm.indexA', function (newVal, oldVal) {
    vm.game();
  }, true)

  $scope.$watch('vm.indexB', function (newVal, oldVal) {
    vm.detailMovementB();
  }, true)

  $scope.$watch('vm.indexC', function (newVal, oldVal) {
    vm.detailBioC();
  }, true)

  $scope.$watch('vm.indexD', function (newVal, oldVal) {
    vm.detailBioD();
  }, true)

  var playerSelectionChange = function () {
    if (vm.appContext.players.game.my_team.entryMain && vm.appContext.players.game.my_team.entryBackup && vm.appContext.players.game.oppo_team.entryMain && vm.appContext.players.game.oppo_team.entryBackup) {
      var arr = vm.appContext.players.game.my_team.entryMain
        .concat(vm.appContext.players.game.my_team.entryBackup)
        .concat(vm.appContext.players.game.oppo_team.entryMain)
        .concat(vm.appContext.players.game.oppo_team.entryBackup);
      vm.user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
      if (!vm.user_id) {
        vm.appContext.selectedType = 'team';
      }
    }
  }

  $scope.$watch('vm.user_id', function (newVal, oldVal) {
    if (newVal !== undefined) {
      vm.game();
    }
  }, true)

  // 팀 변경
  $scope.$watch('vm.appContext.selectedTeamId', function (newVal, oldVal) {
    if (newVal) {
      vm.game();
    }
  })

  // 우리선수 변경
  $scope.$watch('vm.appContext.players.game.my_team.entryMain', function (newVal, oldVal) {
    if (newVal) {
      playerSelectionChange();
    }
  }, true)
  $scope.$watch('vm.appContext.players.game.my_team.entryBackup', function (newVal, oldVal) {
    if (newVal) {
      playerSelectionChange();
    }
  }, true)

  // 상대선수 변경
  $scope.$watch('vm.appContext.players.game.oppo_team.entryMain', function (newVal, oldVal) {
    if (newVal) {
      playerSelectionChange();
    }
  }, true)
  $scope.$watch('vm.appContext.players.game.oppo_team.entryBackup', function (newVal, oldVal) {
    if (newVal) {
      playerSelectionChange();
    }
  }, true)



  vm.next = function (which, next) {
    if (which === 'A') {
      vm.indexA = vm.indexA + next;
      if (vm.indexA == vm.result.movements.length) {
        vm.indexA = 0;
      }
      if (vm.indexA == -1) {
        vm.indexA = vm.result.movements.length - 1;
      }
    }
    if (which === 'B') {
      vm.indexB = vm.indexB + next;
      if (vm.indexB == vm.result.movements.length) {
        vm.indexB = 0;
      }
      if (vm.indexB == -1) {
        vm.indexB = vm.result.movements.length - 1;
      }
    }

    if (which === 'C') {
      vm.indexC = vm.indexC + next;
      if (vm.indexC == vm.categories_C.length) {
        vm.indexC = 0;
      }
      if (vm.indexC == -1) {
        vm.indexC = vm.categories_C.length - 1;
      }
    }

    if (which === 'D') {
      // console.log('next... D', next);
      // console.log('next... vm.indexD', vm.indexD);


      vm.indexD = vm.indexD + next;
      if (vm.indexD == vm.categories_D.length) {
        vm.indexD = 0;
        // console.log('D111', vm.indexD)
      }
      if (vm.indexD == -1) {
        vm.indexD = vm.categories_D.length - 1;
        // console.log('D222', vm.indexD)
      }
    }


  }

  var init = function () {

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      [$stateParams.type_code + '_id']: $stateParams.id,
    };

    PlanService.getGameInfo(data)
      .then(function (res) {
        vm.date = res.data.date;
        vm.info = res.data;
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });

    PlanService.getGameResult(data)
      .then(function (res) {
        // analysis 앱 기준으로 동작 추가 - id 가 0 이거나(공격, 수비, 왼발, 오른발) id 가 151보다 큰 동작 사용
        res.data.movements = _.filter(res.data.movements, function(item) {
          if (item.id != 0) {
            var name = item.name.split('-')[1];

            if (name === '턴' && item.name.split('-')[0] === '트래핑') {
              name = '트래핑-턴';
            }
            item.name = name;
          }

          return item.id == 0 || item.id > 151;
        });

        vm.result = res.data;

        // // 최초 시간별 정보 호출
        vm.game();
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });
  }

  init();

  const h337 = require('heatmap.js');
  let heatmapInstance;

  // heatmap 그리기 함수

  var drawHeatmap = function (height, points) {

    if (!heatmapInstance) {
      heatmapInstance = h337.create({
        container: document.querySelector('#analysis-heatmap'),
        height: height
      });
    }

    var data = {
      // max: 100,
      // max: _.maxBy(points, 'value').value,
      data: points
    };
    if (points.length > 0) {
      data.max = _.maxBy(points, 'value').value;
    }

    heatmapInstance.setData(data);

  };

  vm.chartConfig = {
    chart: {
      zoomType: 'x',
      backgroundColor: 'black',
      type: 'column',
      marginTop: 0,
      marginBottom: 25,
      spacingbottom: 0
    },
    credits: {
      enabled: false
    },
    tooltip: {
      enabled: false
    },
    plotOptions: {
      column: {
        grouping: false,
        pointPadding: 0,
        groupPadding: 0,
        shadow: false,
        borderWidth: 0
      },
      series: {
        cursor: 'pointer',
        point: {
          events: {
            click: function () {
              var category = this.category;
              $scope.$apply(function () {
                vm.secondOrPeriod = 'second';
                vm.second = category;
              })
            }
          }
        },
        dataGrouping: {
          enabled: true
        },
        turboThreshold: 10000
      }
    },

    series: [{
      data: [],
      color: 'steelblue',
      negativeColor: 'indianred',
      states: {
        select: {
          color: 'blue',
          borderColor: 'white'
        }
      },
      allowPointSelect: true
    }],
    title: {
      text: ''
    },
    legend: {
      enabled: false
    },
    xAxis: {
      title: {
        enabled: false
      },
      tickInterval: 300,   // 5분 단위로 표시. 300초 = 5분
      labels: {
        formatter: function() {
          return this.value / 60;   // 초를 분으로 표시하기 위해 60으로 나눔
        }
      }
    },
    yAxis: {
      title: {
        enabled: false
      },
      visible: false
    }
  }



  /**
   * 심박수 선택값 세팅
   */
  let heartbeatMainChart;
  vm.setHeartbeatInfo = function (type, subType) {
    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.heartbeat = type;
    let unit = (type == 'max' || type == 'stable' || type == 'current') ? 'bpm' : ((type == 'recovery') ? '%' : '초');

    let value = vm.bioDataC[type];

    let heartbeatKeyName = 'heartbeat';
    let targetId = '#player-heartbeat-main-chart';

    let max = 220 - 38;

    if (!heartbeatMainChart || heartbeatMainChart.type == 'raidal') {
      heartbeatMainChart = null;
      $(targetId).html('');
    }

    //liquid gauge chart

    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'heartbeat-liquid';
    options.circleColor = '#c833c8';
    options.textColor = '#c833c8';
    options.size = liquidGaugeSize;
    let dataValue = (value / max) * 100;
    console.log('dataValue ............. ', dataValue)
    if (!heartbeatMainChart) {
      heartbeatMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
      heartbeatMainChart['type'] = 'liquid';
    } else {
      heartbeatMainChart.update(Math.round(dataValue));
    }

    let data = {
      title: '심박수',
      value,
      unit
    }
    vm.playerHeartbeatData = data;



  };

  /**
   * 산소 선택값 세팅
   */
  let oxygenMainChart;
  vm.setOxygenInfo = function (type, subType) {
    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.oxygen = type;
    let unit = (type == 'max' || type == 'stable' || type == 'current' || type == 'recovery') ? '%' : '초';
    // let value = vm.playerTotalInfo.oxyzen[0][type];
    let value = vm.bioDataC[type];


    let oxygenKeyName = 'oxygenData';
    let targetId = '#player-oxygen-main-chart';
    if (type == 'reach' || type == 'recovery' || type == 'stable') {
      $scope.oxygenSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.oxyzen[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (oxygenMainChart.type == 'liquid') {
        oxygenMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!oxygenMainChart) {
        oxygenMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        oxygenMainChart.diameter(90).value(value).render();
        oxygenMainChart['type'] = 'raidal';
      } else {
        oxygenMainChart.diameter(90).value(value).render();
      }
    } else {
      if (!oxygenMainChart || oxygenMainChart.type == 'raidal') {
        oxygenMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'oxygen-liquid';
      options.circleColor = '#3187c5';
      options.textColor = '#3187c5';
      options.waveColor = '#3187c5';
      options.size = liquidGaugeSize;
      if (!oxygenMainChart) {
        oxygenMainChart = ChartGeneratorService.loadLiquidFillGauge(value, options);
        oxygenMainChart['type'] = 'liquid';
      } else {
        oxygenMainChart.update(value);
      }
    }
    let data = {
      title: 'Sp02',
      value,
      unit
    };
    vm.playerOxygenData = data;

  };



  /**
   * 젖산 선택값 세팅
   */
  let lacticMainChart;
  vm.setLacticInfo = function (type, subType) {
    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.lactic = type;
    let unit = (type == 'max' || type == 'stable' || type == 'current') ? 'mg/dℓ' : ((type == 'recovery') ? '%' : '초');
    // let value = vm.playerTotalInfo.lactic[0][type];
    let value = vm.bioDataC[type];

    let lacticKeyName = 'lactic';
    let targetId = '#player-lactic-main-chart';
    // let max = vm.playerTotalInfo.lactic[0].max;
    // if (max == 0) {
    //   max = 10;
    // }

    if (!lacticMainChart || lacticMainChart.type == 'raidal') {
      lacticMainChart = null;
      $(targetId).html('');
    }

    //liquid gauge chart
    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'lactic-liquid';
    options.circleColor = '#c833c8';
    options.textColor = '#c833c8';
    options.size = liquidGaugeSize;
    if (!lacticMainChart) {
      lacticMainChart = ChartGeneratorService.loadLiquidFillGauge(value, options);
      lacticMainChart['type'] = 'liquid';
    } else {
      lacticMainChart.update(value);
    }

    let data = {
      title: '젖산',
      value,
      unit
    };
    vm.playerLacticData = data;

  };

  /**
   * 체온 선택값 세팅
   */
  let temperatureMainChart;
  let temperatureChartType;
  vm.setTemperatureInfo = function (type, subType) {

    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.temperature = type;
    let unit = (type == 'max' || type == 'stable' || type == 'current') ? '℃' : ((type == 'recovery') ? '%' : '초');
    // let value = vm.playerTotalInfo.temperature[0][type];
    let value = vm.bioDataC[type];

    let temperatureKeyName = 'temperature';
    let targetId = '#player-temperature-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'recovery') {
      $scope.temperatureSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.temperature[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (temperatureChartType == 'meter') {
        temperatureMainChart = null;
        $(targetId).html('');
      }
      //radial progress bar chart
      if (!temperatureMainChart) {
        temperatureMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        temperatureMainChart.diameter(90).value(chartValue).render();
        temperatureChartType = 'raidal';
      } else {
        temperatureMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      if (!temperatureMainChart || temperatureChartType == 'raidal') {
        temperatureMainChart = null;
        $(targetId).html('');
      }

      let thermometerOptions = {
        targetId: targetId,
        svg_height: 100,
        svg_width: 100,
        svg_style: 'padding-top:3px;',
        max_temp: 44,
        min_temp: 32,
        current_temp: value,
        topY: 5,
        bulb_radius: 12,
        tube_width: 13,
        tube_border_width: 1,
      };
      ChartGeneratorService.createThermometer(thermometerOptions);
      temperatureChartType = 'meter';
    }

    let data = {
      title: '체온',
      value,
      unit
    };
    vm.playerTemperatureData = data;

  }


  /**
   * 거리 선택값 세팅
   */
  let distanceMainChart;
  let distanceChartType;
  vm.setDistanceInfo = function (type, subType) {
    //type : max(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.distance = type;
    // let value = vm.playerTotalInfo.distance[0][type];
    let value = vm.bioDataC[type];


    let distanceKeyName = 'distance';
    let targetId = '#player-distance-main-chart';


    if (!distanceMainChart || distanceChartType == 'raidal') {
      distanceMainChart = null;
      $(targetId).html('');
    }

    if (!distanceMainChart) {
      let configuration = {
        size: 165,
        clipWidth: 158,
        clipHeight: 100,
        ringWidth: 30,
        maxValue: 60,
        transitionMs: 4000,
      }
      distanceMainChart = ChartGeneratorService.createCircularGauge(targetId, configuration)
      distanceMainChart.render();
      distanceChartType = 'gauge';
    }
    distanceMainChart.update(value);


    let data = {
      title: '거리',
      value: value,
      unit: 'km'
    }
    vm.playerDistanceData = data

  };


  /**
   * 속도 선택값 세팅
   */
  let velocityMainChart;
  let velocityChartType;
  vm.setVelocityInfo = function (type, subType) {
    //type : max(최대),stable(안정),reach(도달),average(평균),current(현재)
    //   vm.playerTotalInfo.velocity[0].current = 15;
    //   vm.playerTotalInfo.velocity[0].target = 30;
    //   vm.playerTotalInfo.velocity[0].max = 25;
    //   vm.playerTotalInfo.velocity[0].reach = 45;
    //   vm.playerTotalInfo.velocity[0].average = 20;
    $scope.velocity = type;
    // let value = vm.playerTotalInfo.velocity[0][type];
    let value = vm.bioDataC[type];

    let velocityKeyName = 'velocity';
    let targetId = '#player-velocity-main-chart';

    if (!velocityMainChart || velocityChartType == 'raidal') {
      velocityMainChart = null;
      $(targetId).html('');
    }

    if (!velocityMainChart) {
      let configuration = {
        size: 165,
        clipWidth: 158,
        clipHeight: 100,
        ringWidth: 30,
        maxValue: 60,
        transitionMs: 4000,
      }
      velocityMainChart = ChartGeneratorService.createCircularGauge(targetId, configuration)
      velocityMainChart.render();
      velocityChartType = 'gauge';
    }
    velocityMainChart.update(value);


    let data = {
      title: '속도',
      value: value,
      unit: 'm/s'
    };
    vm.playerVelocityData = data;

  };

  /**
   * 칼로리섭취 선택값 세팅
   */
  let caloryBurnMainChart;
  vm.setCaloryBurnInfo = function (type, subType) {
    //type : max(최대),stable(안정),reach(도달),average(평균),current(현재)
    $scope.caloryburn = type;
    // let value = vm.playerTotalInfo.calrorie_burned[0][type];
    let value = vm.bioDataC[type];

    let caloryBurnKeyName = 'caloryburn';
    let targetId = '#player-burn-main-chart';

    let max = vm.bioDataC.max;
    let dataValue;
    if (max == 0) {
      max = 100;
      dataValue = 0;
    } else {
      dataValue = (value / max) * 100;
    }

    if (!caloryBurnMainChart || caloryBurnMainChart.type == 'raidal') {
      caloryBurnMainChart = null;
      $(targetId).html('');
    }

    //liquid gauge chart
    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'calory-burn-liquid';
    options.circleColor = '#c833c8';
    options.textColor = '#c833c8';
    options.size = liquidGaugeSize;
    if (!caloryBurnMainChart) {
      caloryBurnMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
      caloryBurnMainChart['type'] = 'liquid';
    } else {
      caloryBurnMainChart.update(Math.round(dataValue));
    }

    let data = {
      title: '칼로리소모',
      value: number_format(value),
      unit: 'kcal'
    };
    vm.playerBurnData = data;

  }


  /**
   * 체중 선택값 세팅
   */
  let weightMainChart;
  let weightChartType;
  vm.setWeightInfo = function (type, subType) {
    //type : target(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.weight = type;
    // let value = vm.playerTotalInfo.weight[0][type];
    let value = vm.bioDataC[type];

    let weightKeyName = 'weight';
    let targetId = 'player-weight-main-chart';

    if (!weightMainChart || weightChartType == 'raidal') {
      weightMainChart = null;
      $('#player-weight-main-chart').html('');
    }
    /* weight gauges chart */
    if (!weightMainChart) {
      let size = 100;
      weightMainChart = ChartGeneratorService.createGaugeChart(targetId, weightKeyName, size);
      weightChartType = 'gauge';
    }
    ChartGeneratorService.updateGaugeChart(value, weightMainChart, targetId);

    let data = {
      title: '체중',
      value,
      unit: 'kg'
    };
    vm.playerWeightData = data;

  };

  /**
   * 부상 선택값 세팅
   */
  vm.setInjuryInfo = function (type) {

    console.log('type', type)
    console.log('vm.bioDataD', vm.bioDataD)
    if (type === '현재') {
      type = '정상'
    }
    var injury = _.find(vm.bioDataD.injury, {
      istate: type
    })
    vm.playerinjuryData = {
      title: injury.istate,
      value: injury.days,
      unit: "day"
    }
  };



  // 히트맵 탭 클릭
  vm.changeHeatmapTab = function (mode) {
    vm.activeHeatmapTab = mode;
    vm.setMovementsInfo([vm.selectedSkill, vm.selectedLocation, vm.selectedFoot]);
  };


  /*
   * tracking 차트 시작
   */
  let trackingChartInstance = null;
  let trackingChartTimer = null;

  function drawTrackingChart(mode) {
    let ground;
    let groundWidth;
    let groundHeight;

    if (mode === 'full-ground') {   // 전체 경기장
      ground = $('#design-full-ground');
      groundWidth = ground.width();
      groundHeight = parseInt((groundWidth * AppSettings.location.fieldHeight) / AppSettings.location.fieldWidth, 10);  // 배경 이미지 비율에 맞게 높이 결정
    } else if (mode === 'half-ground') {  // 경기장 반
      ground = $('#design-half-ground');
      groundWidth = ground.width();
      groundHeight = parseInt((groundWidth * AppSettings.location.halfFieldHeight) / AppSettings.location.halfFieldWidth, 10);  // 배경 이미지 비율에 맞게 높이 결정
    } else if (mode === 'small-ground') { // 잔디밭
      ground = $('#design-small-ground');
      groundWidth = ground.width();
      groundHeight = parseInt((groundWidth * AppSettings.location.smallFieldHeight) / AppSettings.location.smallFieldWidth, 10);  // 배경 이미지 비율에 맞게 높이 결정
    }

    groundWidth = document.getElementById('analysis-heatmap-bg').clientWidth;
    groundHeight = document.getElementById('analysis-heatmap-bg').clientHeight;

    ground.height(groundHeight);

    // tracking 차트 그리기
    trackingChartInstance = ground.highcharts();
    if (trackingChartInstance) {
      trackingChartInstance.destroy();
    }

    let width = groundWidth;
    let height = groundHeight;

    let data = [{
      x: 50,
      y: 45,
      z: 10,
      name: '곽태휘',
      back_number: 5
    },
    {
      x: 26.5,
      y: 72.9,
      z: 10,
      name: '권순태',
      back_number: 1
    },
    {
      x: 85.8,
      y: 91.5,
      z: 10,
      name: '김진수',
      back_number: 4
    },
    {
      x: 50.4,
      y: 30.5,
      z: 10,
      name: '기성용',
      back_number: 6
    },
    {
      x: 30.3,
      y: 80.1,
      z: 10,
      name: '장현수',
      back_number: 2
    },
    {
      x: 75.4,
      y: 7.1,
      z: 10,
      name: '최철순',
      back_number: 3
    },
    {
      x: 74.2,
      y: 60.5,
      z: 10,
      name: '한국영',
      back_number: 14
    },
    {
      x: 33.5,
      y: 83.1,
      z: 10,
      name: '손흥민',
      back_number: 7
    },
    {
      x: 72,
      y: 23.2,
      z: 10,
      name: '이재성',
      back_number: 17
    },
    {
      x: 59.2,
      y: 47.6,
      z: 10,
      name: '지동원',
      back_number: 10
    },
    {
      x: 58.6,
      y: 30,
      z: 10,
      name: '황희찬',
      back_number: 9
    }
    ];

    Highcharts.chart('design-' + mode, {

      chart: {
        type: 'bubble',
        width: width,
        height: height,
        backgroundColor: 'transparent',
        margin: [0, 25, 0, 25]
      },

      credits: {
        enabled: false
      },

      legend: {
        enabled: false
      },

      title: {
        text: ''
      },

      tooltip: {
        enabled: false
      },

      xAxis: {
        gridLineWidth: 0,
        labels: {
          enabled: false
        },
        tickLength: 0
      },

      yAxis: {
        startOnTick: false,
        endOnTick: false,
        gridLineWidth: 0,
        title: {
          enabled: false
        },
        labels: {
          enabled: false
        }
      },

      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{point.back_number}',
            style: {
              fontSize: '16px'
            }
          },
          marker: {
            fillOpacity: 0.7,
            lineColor: '#333',
            lineWidth: 1
          }
        },
        bubble: {
          maxSize: 40
        }
      },

      series: [{
        color: '#fdcc00',
        data: data
      }]
    });

    if (trackingChartTimer) {
      clearInterval(trackingChartTimer);
    }

    trackingChartTimer = setInterval(function () {
      let chart = ground.highcharts();

      _.forEach(data, function (item) {
        if (Math.random() > 0.5) {
          item.x = item.x + 1;
        } else {
          item.x = item.x - 1;
        }

        if (Math.random() > 0.5) {
          item.y = item.y + 1;
        } else {
          item.y = item.y - 1;
        }
      });

      _.forEach(chart.series[0].data, function (item, i) {
        item.update({
          x: data[i].x,
          y: data[i].y
        }, false, false);
      });

      chart.redraw();
    }, 800);
  }

  $scope.$on('$viewContentLoaded', function (event) {
    // groundHeight 값이 0 으로 나와서 약간의 시간 뒤에 실행
    $timeout(function() {
      drawTrackingChart('full-ground');
    }, 1000);
  });
  // tracking 차트 끝


}

export default {
  name: 'EventAnalysisCtrl',
  fn: EventAnalysisCtrl
};
